import { updateWidgetLayout } from "actions/editor";
import { FORM_CHECK_BOX, FORM_CHECK_LIST, FORM_DROPDOWN_LIST, FORM_FIELD, FORM_NUMBER, FORM_TEXTAREA, OTP_INPUT } from "constants/widgetTypes";
import _ from "lodash";
import { getBoundingRectForWidget, getBoundingRectFromLayout } from "./layoutManager";

import { Frame } from 'scenejs';

const fieldWidget = (config) => {

  switch (config.type) {

    case 'string_field':
      return {
        type: FORM_FIELD,
        name: config.name,
        properties: {
          desktop: {
            visible: true,
            field: config.userDefined ? config.type : _.get(config, 'uid', config.type) ,
            label: config.name,
            placeholder: config.placeholder,
            mandatory: false,
            layout: {
              transform: {
                translate: `${config.x}px, ${config.y}px`,
                rotate: "0deg"
              },
              width: '540px',
              height: 'auto'
            },
            styles: {
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                regular: null
              },
              regular: {
                border: {
                  sides: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  width: "2",
                  radius: null,
                  style: "bottom"
                },
                label: {
                  background: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: null,
                  font: {
                    style: null,
                    fontSize: "12",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                },
                input: {
                  background: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1
                  },
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: {
                    r: 213,
                    g: 213,
                    b: 213,
                    a: 1
                  },
                  font: {
                    style: null,
                    fontSize: "14",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                }
              }
            }
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: `${config.xMobile}px, ${config.yMobile}px`,
                rotate: "0deg"
              },
              width: '295px',
              height: 'auto'
            },
            styles:{
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                regular: null
              }
            }
            
          }
        },
        content: config
      }

    case 'string_field':
      return {
        type: OTP_INPUT,
        name: config.name,
        properties: {
          desktop: {
            visible: true,
            field: config.userDefined ? config.type : _.get(config, 'uid', config.type) ,
            label: config.name,
            placeholder: config.placeholder,
            mandatory: false,
            layout: {
              transform: {
                translate: `${config.x}px, ${config.y}px`,
                rotate: "0deg"
              },
              width: '540px',
              height: 'auto'
            },
            styles: {
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                regular: null
              },
              regular: {
                border: {
                  sides: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  width: "2",
                  radius: null,
                  style: "bottom"
                },
                label: {
                  background: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: null,
                  font: {
                    style: null,
                    fontSize: "12",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                },
                input: {
                  background: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1
                  },
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: {
                    r: 213,
                    g: 213,
                    b: 213,
                    a: 1
                  },
                  font: {
                    style: null,
                    fontSize: "14",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                }
              }
            }
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: `0px, 0px`,
                rotate: "0deg"
              },
              width: '295px',
              height: 'auto'
            },
            styles:{
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                regular: null
              }
            }
            
          }
        },
        content: config
      }
      
      case 'number_field':
      return {
        type: FORM_NUMBER,
        name: config.name,
        properties: {
          desktop: {
            visible: true,
            field: config.type,
            label: config.name,
            placeholder: config.placeholder,
            mandatory: false,
            layout: {
              transform: {
                translate: `${config.x}px, ${config.y}px`,
                rotate: "0deg"
              },
              width: '540px',
              height: 'auto'
            },
            styles: {
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                regular: null
              },
              regular: {
                border: {
                  sides: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  width: "2",
                  radius: null,
                  style: "bottom"
                },
                label: {
                  background: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: null,
                  font: {
                    style: null,
                    fontSize: "12",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                },
                input: {
                  background: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1
                  },
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: {
                    r: 213,
                    g: 213,
                    b: 213,
                    a: 1
                  },
                  font: {
                    style: null,
                    fontSize: "14",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                }
              }
            }
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: `${config.xMobile}px, ${config.yMobile}px`,
                rotate: "0deg"
              },
              width: '295px',
              height: 'auto'
            },
            styles:{
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                regular: null
              }
            }
          }
        },
        content: config
      }

      case 'textarea_field':
        return {
          type: FORM_TEXTAREA,
          name: config.name,
          properties: {
            desktop: {
              visible: true,
              field: config.type,
              label: config.name,
              placeholder: config.placeholder,
              mandatory: false,
              layout: {
                transform: {
                  translate: `${config.x}px, ${config.y}px`,
                  rotate: "0deg"
                },
                width: '540px',
                height: 'auto'
              },
              styles: {
                layout: {
                  alignment: "left",
                  labelPadding: "0",
                  inputPadding: "12",
                  fieldSpacing: "2",
                  regular: null
                },
                regular: {
                  border: {
                    sides: null,
                    color: {
                      r: 0,
                      g: 0,
                      b: 0,
                      a: 1
                    },
                    width: "2",
                    radius: null,
                    style: "bottom"
                  },
                  label: {
                    background: null,
                    color: {
                      r: 0,
                      g: 0,
                      b: 0,
                      a: 1
                    },
                    placeholderColor: null,
                    font: {
                      style: null,
                      fontSize: "12",
                      fontFamily: "Montserrat,sans-serif",
                      lineSpacing: null,
                      letterSpacing: null,
                      color: null
                    }
                  },
                  input: {
                    background: {
                      r: 255,
                      g: 255,
                      b: 255,
                      a: 1
                    },
                    color: {
                      r: 0,
                      g: 0,
                      b: 0,
                      a: 1
                    },
                    placeholderColor: {
                      r: 213,
                      g: 213,
                      b: 213,
                      a: 1
                    },
                    font: {
                      style: null,
                      fontSize: "14",
                      fontFamily: "Montserrat,sans-serif",
                      lineSpacing: null,
                      letterSpacing: null,
                      color: null
                    }
                  }
                }
              }
            },
            mobile: {
              visible: true,
              layout: {
                transform: {
                  translate: `${config.xMobile}px, ${config.yMobile}px`,
                  rotate: "0deg"
                },
                width: '295px',
                height: 'auto'
              },
              styles:{
                layout: {
                  alignment: "left",
                  labelPadding: "0",
                  inputPadding: "12",
                  fieldSpacing: "2",
                  regular: null
                }
              }
            }
          },
          content: config
        }

    case 'list_field':
      return {
        type: FORM_DROPDOWN_LIST,
        name: config.name,
        properties: {
          desktop: {
            visible: true,
            field: config.type,
            label: config.name,
            placeholder: config.placeholder,
            mandatory: false,
            layout: {
              transform: {
                translate: `${config.x}px, ${config.y}px`,
                rotate: "0deg"
              },
              width: '540px',
              height: 'auto'
            },
            styles: {
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                spaceBetweenItems: "2",
                horizontalPadding: "8",
                verticalPadding: "8",
                regular: null
              },
              regular: {
                border: {
                  sides: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  width: "2",
                  radius: null,
                  style: "bottom"
                },
                label: {
                  background: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: null,
                  font: {
                    style: null,
                    fontSize: "12",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                },
                input: {
                  background: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1
                  },
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: {
                    r: 213,
                    g: 213,
                    b: 213,
                    a: 1
                  },
                  font: {
                    style: null,
                    fontSize: "14",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                }
              },
              openProperty: {
                border: {
                  sides: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  width: "2",
                  radius: null,
                  style: "bottom"
                },
                background: {
                  r: 255,
                  g: 255,
                  b: 255,
                  a: 1
                },
                text: {
                  r: 0,
                  g: 0,
                  b: 0,
                  a: 1
                }
              }
            }
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: `${config.xMobile}px, ${config.yMobile}px`,
                rotate: "0deg"
              },
              width: '295px',
              height: 'auto'
            },
            styles:{
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                spaceBetweenItems: "2",
                horizontalPadding: "8",
                verticalPadding: "8",
                regular: null
              }
            }
          }
        },
        content: config
      }

      case 'checkList_field':
        return {
          type: FORM_CHECK_LIST,
          name: config.name,
          properties: {
            desktop: {
              visible: true,
              field: config.type,
              label: config.name,
              placeholder: config.placeholder,
              mandatory: false,
              layout: {
                transform: {
                  translate: `${config.x}px, ${config.y}px`,
                  rotate: "0deg"
                },
                width: '540px',
                height: 'auto'
              },
              styles: {
                layout: {
                  alignment: "left",
                  labelPadding: "0",
                  inputPadding: "0",
                  fieldSpacing: "2",
                  spaceBetweenItems: "2",
                  horizontalPadding: "0",
                  verticalPadding: "0",
                  regular: null
                },
                regular: {
                  label: {
                    background: null,
                    color: {
                      r: 0,
                      g: 0,
                      b: 0,
                      a: 1
                    },
                    placeholderColor: null,
                    font: {
                      style: null,
                      fontSize: "12",
                      fontFamily: "Montserrat,sans-serif",
                      lineSpacing: null,
                      letterSpacing: null,
                      color: null
                    }
                  },
                  input: {
                    color: {
                      r: 0,
                      g: 0,
                      b: 0,
                      a: 1
                    },
                    font: {
                      style: null,
                      fontSize: "14",
                      fontFamily: "Montserrat,sans-serif",
                      lineSpacing: null,
                      letterSpacing: null,
                      color: null
                    }
                  }
                }
              }
            },
            mobile: {
              visible: true,
              layout: {
                transform: {
                  translate: `${config.xMobile}px, ${config.yMobile}px`,
                  rotate: "0deg"
                },
                width: '295px',
                height: 'auto'
              },
              styles:{
                layout: {
                  alignment: "left",
                  labelPadding: "0",
                  inputPadding: "0",
                  fieldSpacing: "2",
                  spaceBetweenItems: "2",
                  horizontalPadding: "0",
                  verticalPadding: "0",
                  regular: null
                }
              }
            }
          },
          content: config
        }

    case 'boolean_field':
      return {
        type: FORM_CHECK_BOX,
        name: config.name,
        properties: {
          desktop: {
            visible: true,
            field: config.type,
            label: config.name,
            placeholder: config.placeholder,
            mandatory: false,
            layout: {
              transform: {
                translate: `${config.x}px, ${config.y}px`,
                rotate: "0deg"
              },
              width: '540px',
              height: 'auto'
            },
            styles: {
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "4",
                fieldSpacing: "2",
                regular: null
              },
              regular: {
                border: {
                  sides: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  width: "2",
                  radius: null,
                  style: "bottom"
                },
                label: {
                  background: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: null,
                  font: {
                    style: null,
                    fontSize: "12",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                },
                input: {
                  background: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1
                  },
                  color: {
                    r: 91,
                    g: 91,
                    b: 91,
                    a: 1
                  },
                  placeholderColor: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  font: {
                    style: null,
                    fontSize: "14",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                }
              }
            }
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: `${config.xMobile}px, ${config.yMobile}px`,
                rotate: "0deg"
              },
              width: '295px',
              height: 'auto'
            },
            styles:{
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "4",
                fieldSpacing: "2",
                regular: null
              }
            }
          }
        },
        content: config
      }

    default:
      return {
        type: FORM_FIELD,
        name: config.label,
        properties: {
          desktop: {
            visible: true,
            field: config.field,
            label: config.label,
            placeholder: config.placeholder,
            mandatory: false,
            layout: {
              transform: {
                translate: `${config.x}px, ${config.y}px`,
                rotate: "0deg"
              },
              width: '540px',
              height: 'auto'
            },
            styles: {
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                regular: null
              },
              regular: {
                border: {
                  sides: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  width: "2",
                  radius: null,
                  style: "bottom"
                },
                label: {
                  background: null,
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: null,
                  font: {
                    style: null,
                    fontSize: "12",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                },
                input: {
                  background: {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: 1
                  },
                  color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                  },
                  placeholderColor: {
                    r: 213,
                    g: 213,
                    b: 213,
                    a: 1
                  },
                  font: {
                    style: null,
                    fontSize: "14",
                    fontFamily: "Montserrat,sans-serif",
                    lineSpacing: null,
                    letterSpacing: null,
                    color: null
                  }
                }
              }
            }
          },
          mobile: {
            visible: true,
            layout: {
              transform: {
                translate: `${config.xMobile}px, ${config.yMobile}px`,
                rotate: "0deg"
              },
              width: '295px',
              height: 'auto'
            },
            styles:{
              layout: {
                alignment: "left",
                labelPadding: "0",
                inputPadding: "12",
                fieldSpacing: "2",
                regular: null
              }
            }
          }
        },
        content: config
      }
  }
};

const extractTranslateValues = (transform) => {
  if (!transform || typeof transform.translate !== "string") {
    return { translateX: 0, translateY: 0 };
  }

  const translateValues = transform.translate.split(",").map(value => parseFloat(value));

  return {
    translateX: translateValues[0] || 0,
    translateY: translateValues[1] || 0
  };
};

export const createAddFieldRequest = (editorSession, form, field, afterField) => {

  const rect = getBoundingRectForWidget(editorSession, afterField);
  const mobileTransform = _.get(afterField, "properties.mobile.layout.transform", {});

  const { translateX, translateY } = extractTranslateValues(mobileTransform);

  const x = rect.x;
  const y = rect.y + rect.height + 30;

  const fieldConfig = {
    ...field,
    x: x,
    y: y,
    xMobile: translateX,
    yMobile: translateY + rect.height + 30
  }

  const fieldRequest = fieldWidget(fieldConfig);
  return fieldRequest;
}

export const changeFieldTypeRequest = (editorSession, form, field, afterField) => {

  const rect = getBoundingRectForWidget(editorSession, afterField);

  const x = rect.x;
  const y = rect.y;

  const fieldConfig = {
    ...field,
    x: x,
    y: y
  }

  const fieldRequest = fieldWidget(fieldConfig);
  return fieldRequest;
}

export const moveWidgetsInForm = (editorSession, widgets, lastField) => {
  const fieldRect = getBoundingRectForWidget(editorSession, lastField);
  const layoutMobile = _.get(lastField, 'properties.mobile.layout');
  const fieldRectMobile = getBoundingRectFromLayout(layoutMobile);
  const topOffset = fieldRect.y + fieldRect.height - 2;
  const topOffsetMobile = fieldRectMobile.y + fieldRect.height - 2;
  const heightOffset = fieldRect.height + 30;

  const moveWidgets = (breakpoint, Offset) => {
    return widgets.filter(widget => {
      const layout = _.get(widget, `properties.${breakpoint}.layout`);
      const rect = getBoundingRectFromLayout(layout);
      return rect.y >= Offset;
    }).map(widget => {
      const layout = _.get(widget, `properties.${breakpoint}.layout`);
      const rect = getBoundingRectFromLayout(layout);

      const frame = new Frame(layout);
      const x = rect.x;
      const y = rect.y + heightOffset;

      frame.set('transform', 'translate', `${x}px, ${y}px`);

      return updateWidgetLayout(editorSession, widget.uid, breakpoint, frame.get());
    });
  }

  const desktopRequests = moveWidgets('desktop', topOffset);
  const mobileRequests = moveWidgets('mobile', topOffsetMobile);

  return [...desktopRequests, ...mobileRequests];

}

export const calculateHeightForForm = (editorSession, breakpoint, form) => {

}